export function addUserData (user) {
  if (!user) return
  const subscriptionPlan = user.subscriptions.length > 0 ? `${user.subscriptions[0].plan_name}` : null
  window.$chatwoot.setUser(
    user.id,
    {
      email: user.email,
      name: `${user.first_name} ${user.last_name}`
    }
  )
  window.$chatwoot.setCustomAttributes({
    subscriptionPlan: subscriptionPlan,
    userId: user.id
  })
}
